// 9fbef606107a605d69c0edbcd8029e5d
import { getBrandInCaps } from '@tcp/core/src/utils/utils';
import { formValueSelector, getFormSyncErrors } from 'redux-form';
import { CHECKOUT_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';

const getSyncError = (state) => {
  return {
    syncError: getFormSyncErrors('checkoutShipping')(state),
  };
};

const getGiftServicesFormData = (state) => {
  const selector = formValueSelector('GiftServices');
  return {
    catEntryId: selector(state, 'optionId'),
    hasGiftWrapping: selector(state, 'hasGiftWrapping'),
    GiftMsg: selector(state, 'message'),
    brand: selector(state, 'brand') || getBrandInCaps(),
  };
};

const getPaypalPaymentSettings = (state) => {
  return state.Checkout.getIn(['options', 'paypalPaymentSettings']);
};

const getExpressReviewShippingSectionId = (state) => {
  const selector = formValueSelector('expressReviewPage');
  return selector(state, 'expressReviewShippingSection');
};

const getDefaultShipmentMethods = (state) => {
  return parseInt(state.session.siteDetails.DEFAULT_SHIPMENT_METHODS_ENABLED, 10) || 0;
};

const getIsOptimseUpdateShipment = (state) => {
  return parseInt(state.session.siteDetails.OPTIMISE_UPDATESHIPMENT, 10) || 0;
};

const getIsAfterPayInProgress = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'afterPayInProgress']);
};

const getIsAfterPayPaymentProgress = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'afterPayPaymentProgress']);
};

const getIsPaypalPaymentProgress = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'paypalPaymentInProgress']);
};

const getShowCouponsDrawer = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'showCouponsDrawer']);
};

const getReviewFormValues = (state) => {
  const reviewFormName = 'expressReviewPage';
  return state && state.form && state.form[reviewFormName] && state.form[reviewFormName].values;
};

export {
  getGiftServicesFormData,
  getSyncError,
  getPaypalPaymentSettings,
  getExpressReviewShippingSectionId,
  getDefaultShipmentMethods,
  getIsOptimseUpdateShipment,
  getIsAfterPayInProgress,
  getReviewFormValues,
  getIsAfterPayPaymentProgress,
  getShowCouponsDrawer,
  getIsPaypalPaymentProgress,
};
